import { Brand } from "@/components/Brand";
import { Credits } from "@/components/Footer";

const IMG =
  "https://images.unsplash.com/photo-1514369118554-e20d93546b30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const AuthShell = ({ eyebrow, title, children, dark }) => (
  <div className="min-h-screen grid lg:grid-cols-12">
    <div className={`lg:col-span-7 flex flex-col px-6 sm:px-12 lg:px-20 py-10 ${dark ? "bg-zinc-950 text-white" : "bg-[#FBFBFC]"}`}>
      <div className={dark ? "[&_span]:!text-white [&_.bg-zinc-950]:!bg-white" : ""}>
        <Brand to="/login" sub={dark ? "Super Admin Console" : "Studio assistito AI"} />
      </div>
      <div className="flex-1 flex items-center py-12">
        <div className="w-full max-w-xl rise">
          <img src={`${process.env.PUBLIC_URL}/logo512.png`} alt="Logo Aurora School" data-testid="auth-hero-logo" className="w-24 h-24 sm:w-28 sm:h-28 rounded-3xl mb-8 shadow-[0_10px_30px_-10px_rgba(16,185,129,0.45)]" />
          <p className={`font-mono text-xs uppercase tracking-widest mb-4 ${dark ? "text-[#5EEAD4]" : "text-[#0D9488]"}`}>{eyebrow}</p>
          <h1 className={`font-display text-4xl sm:text-5xl font-extrabold ${dark ? "text-brand-gradient-light" : "text-brand-gradient"} tracking-tight leading-[1.05] mb-10`}>{title}</h1>
          {children}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2">
        <p className={`font-mono text-[10px] uppercase tracking-widest ${dark ? "text-zinc-500" : "text-zinc-400"}`}>
          © Aurora School — Piattaforma didattica
        </p>
        <Credits dark={dark} />
      </div>
    </div>
    <div className="hidden lg:block lg:col-span-5 relative border-l border-zinc-200 overflow-hidden">
      <img src={IMG} alt="Studentessa che studia" className="absolute inset-0 w-full h-full object-cover grayscale" />
      <div className="absolute inset-0 bg-zinc-950/30" />
      <div className="absolute bottom-0 left-0 right-0 p-10 bg-white border-t border-zinc-200">
        <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-2">Metodo</p>
        <p className="font-display text-2xl font-bold tracking-tight text-zinc-950">Leggi. Sintetizza. Ricorda.</p>
        <div className="flex gap-1 mt-4">
          {["#DC2626", "#2563EB", "#059669", "#D97706", "#7C3AED"].map((c) => (
            <span key={c} className="h-1.5 flex-1" style={{ background: c }} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-xs font-semibold uppercase tracking-wider text-zinc-600 mb-2">{label}</span>
    {children}
  </label>
);

export const inputCls =
  "w-full h-12 px-4 bg-white border border-zinc-300 text-zinc-950 placeholder:text-zinc-400 focus:outline-none focus:border-zinc-950 focus:ring-1 focus:ring-zinc-950 transition-colors duration-150";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 h-12 px-6 bg-[#0D9488] text-white font-semibold hover:bg-[#059669] disabled:opacity-50 transition-colors duration-150";
